<script>
  import SpotifyMusicEmbed from './SpotifyMusicEmbed.svelte';
</script>

<div class="music-player">
  <SpotifyMusicEmbed />
</div>

<style>
  .music-player {
    text-align: center;
  }
</style>
